import { render, staticRenderFns } from "./AccountCustomization.vue?vue&type=template&id=e5578f54&scoped=true"
import script from "./AccountCustomization.vue?vue&type=script&lang=js"
export * from "./AccountCustomization.vue?vue&type=script&lang=js"
import style0 from "./AccountCustomization.vue?vue&type=style&index=0&id=e5578f54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5578f54",
  null
  
)

export default component.exports